import { render, staticRenderFns } from "./AjustesDestino.vue?vue&type=template&id=52550448&scoped=true"
import script from "./AjustesDestino.vue?vue&type=script&lang=js"
export * from "./AjustesDestino.vue?vue&type=script&lang=js"
import style0 from "./AjustesDestino.vue?vue&type=style&index=0&id=52550448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52550448",
  null
  
)

export default component.exports